import { Fab, useTheme, CircularProgress } from '@mui/material'
import { Loader, theme as eidTheme } from 'packages/eid-ui'

const Button = ({
    onClick,
    loading,
    children,
    color,
    fill,
    isFilled,
    isDisabled,
}) => {
    const theme = useTheme()

    const commonStyles = {
        minWidth: '80px',
        height: '31px',
        boxShadow: '0 0 0 0',
        textTransform: 'capitalize !important',
        lineHeight: 1,
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        '& .MuiFab-label': {
            width: 'auto !important',
        },
        '&:hover': {
            color: theme?.palette?.common?.white,
            '& path': {
                fill: theme?.palette?.common?.white,
            },
            '& span': {
                color: theme?.palette?.common?.white,
            },
        },
    }

    const filledStyles = {
        border: `solid 1px ${color}`,
        backgroundColor: fill,
        color: theme?.palette?.common?.white,
        '&:hover': {
            backgroundColor: fill,
            border: `solid 1px ${fill}`,
        },
    }

    const outlinedStyles = {
        border: `solid 1px ${color}`,
        backgroundColor: loading ? color : theme?.palette?.common?.white,
        color: loading ? theme?.palette?.common?.white : color,
        '& path': {
            fill: color,
        },
        '&:hover': {
            backgroundColor: loading ? theme?.palette?.common?.white : color,
            color: loading ? color : theme?.palette?.common?.white,
        },
    }

    return (
        <Fab
            sx={{
                ...commonStyles,
                ...(isFilled ? filledStyles : outlinedStyles),
            }}
            variant="extended"
            onClick={onClick}
            disabled={isDisabled}
        >
            {loading ? (
                <div
                    style={{
                        width: '12px',
                    }}
                >
                    <Loader
                        color={theme?.palette?.common?.white}
                        height="100%"
                        size={0.5}
                        display="inline"
                    />
                </div>
            ) : (
                children
            )}
        </Fab>
    )
}

Button.defaultProps = {
    color: eidTheme?.palette?.secondary?.main,
}

export default Button
